import React, { useEffect, useRef } from 'react';
import ld1 from '../../assets/images/ld1.png';
import ld2 from '../../assets/images/ld2.png';
import ld3 from '../../assets/images/ld3.png';
import ld4 from '../../assets/images/ld4.png';
import ld5 from '../../assets/images/ld5.png';
import ld6 from '../../assets/images/ld6.png';

const dishImages = [ld1, ld2, ld3, ld4, ld5, ld6];

const LegendDishes: React.FC = () => {
  const sectionRef = useRef<HTMLElement>(null);
  const trackRef = useRef<HTMLDivElement>(null);
  const pausedRef = useRef(false);

  useEffect(() => {
    const track = trackRef.current;
    const section = sectionRef.current;
    if (!track || !section) return;

    let animationId: number;
    let currentX = 0;
    const speed = 0.5;

    const animate = () => {
      if (!pausedRef.current) {
        currentX -= speed;
        const singleSetWidth = track.scrollWidth / 3;
        if (Math.abs(currentX) >= singleSetWidth) {
          currentX += singleSetWidth;
        }
        track.style.transform = `translateX(${currentX}px)`;
      }
      animationId = requestAnimationFrame(animate);
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animationId = requestAnimationFrame(animate);
          } else {
            cancelAnimationFrame(animationId);
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(section);

    return () => {
      observer.disconnect();
      cancelAnimationFrame(animationId);
    };
  }, []);

  return (
    <section
      ref={sectionRef}
      className="w-full overflow-hidden"
      style={{ background: '#FFF2DA', paddingTop: 'clamp(60px, 12vw, 200px)', paddingBottom: 'clamp(60px, 12vw, 200px)' }}
    >
      {/* Section Header */}
      <div className="text-center" style={{ marginBottom: 'clamp(20px, 4vw, 50px)', padding: '0 1rem' }}>
        <h2
          className="font-teko font-medium uppercase tracking-wide"
          style={{ color: '#0B5026', fontSize: 'clamp(36px, 8vw, 110.7px)', lineHeight: '1.1' }}
        >
          THE LEGENDS OF MENU
        </h2>
        <p
          className="font-inter font-normal mx-auto"
          style={{
            color: '#1E1E1E',
            fontSize: 'clamp(14px, 2.5vw, 29.5px)',
            lineHeight: '1.5',
            maxWidth: '900px',
            padding: '0 1rem',
          }}
        >
          Our legendary dishes that put smile on faces, keep people
          coming back, and make first visits unforgettable.
        </p>
      </div>

      {/* Scrolling Images */}
      <div
        className="overflow-hidden w-full"
        onMouseEnter={() => { pausedRef.current = true; }}
        onMouseLeave={() => { pausedRef.current = false; }}
      >
        <div
          ref={trackRef}
          className="flex items-start"
          style={{ width: 'max-content' }}
        >
          {[...dishImages, ...dishImages, ...dishImages].map((src, index) => (
            <div
              key={index}
              className="flex-shrink-0 relative group cursor-pointer"
              style={{
                width: 'clamp(220px, 35vw, 494px)',
                height: 'clamp(260px, 40vw, 574px)',
                marginRight: 'clamp(12px, 2vw, 24px)',
              }}
            >
              <img
                src={src}
                alt={`Legend Dish ${(index % 6) + 1}`}
                className="w-full h-full object-cover"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LegendDishes;
